module.exports = [{"type":"title","text":"2025-04-25"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續幣本位：下單、撤單和查單支持clientOrderId"},{"type":"html","text":"現貨：balance接口新增displayName字段"},{"type":"html","text":"錢包&賬戶：提幣接口新增‘現貨賬戶’類型"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-04-25.json
// module id = CBF0
// module chunks = 3